export default {
    currentSlide: 0,
    blogCount: 4,
}
